import React from "react";

const PolicyModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[1300] flex items-center justify-center overflow-y-auto bg-black/60 backdrop-blur-sm px-4 py-12 md:py-16"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="w-full max-w-4xl my-6 md:my-10"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="overflow-hidden rounded-3xl bg-white shadow-2xl">
          <div className="flex items-start justify-between bg-gradient-to-r from-[#4C3C67] via-[#625480] to-[#8A75A6] px-6 py-5 text-white">
            <div className="flex-1 pr-8">
              {title && (
                <>
                  <h2 className="text-2xl font-semibold leading-snug tracking-wide">
                    {title}
                  </h2>
                  <p className="mt-1 text-sm text-white/80">
                    Please review the document below.
                  </p>
                </>
              )}
            </div>
            <button
              onClick={onClose}
              className="rounded-full border border-white/40 p-2 text-white transition hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/60"
              aria-label="Close"
            >
              <span className="block text-xl leading-none">×</span>
            </button>
          </div>
          <div className="max-h-[65vh] md:max-h-[70vh] overflow-y-auto px-6 py-6 text-gray-800">
            <div className="prose max-w-none text-sm leading-relaxed [&_h2]:mt-8 [&_h2]:text-2xl [&_h3]:mt-6 [&_h3]:text-xl [&_ul]:list-disc [&_ul]:pl-6">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
